/** Returns fixed CSS position for a tooltip popover, flipping below if near top of viewport. */
export function useTooltipPosition(x: number, y: number): { top: number; left: number } {
  const POPOVER_HEIGHT = 140;
  const top = y < POPOVER_HEIGHT + 20 ? y + 12 : y - POPOVER_HEIGHT - 12;
  const left = Math.min(Math.max(x - 120, 8), window.innerWidth - 250);
  return { top, left };
}
